import React from "react";
import { Modal, Button } from "react-bootstrap";

const ExamModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size="lg"
      className="exam-modal"
    >
      <Modal.Header className="modal-bg text-white">
        <Modal.Title>Ready to Begin Exam</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex align-items-start gap-3">
      <i className="bi bi-question-circle fs-2 modal-icon"></i>
        <p>
        Please select your preferred exam type: Timed or Untimed.
        Then, click "Start Timed Exam" or "Start Untimed Exam" to begin.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={()=>onConfirm('time')}
          className="px-4 py-2 modal-btn"
        >
          Start Timed Exam
        </Button>
        <Button
          onClick={()=>onConfirm('no_time')}
          className="px-4 py-2 modal-btn"
        >
          Start Untimed Exam
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExamModal;
